import { APIHandler } from "utilities/apiHandler";

import { type CategoryType } from "../common/categoryType";
import {
    CategoryDeleteResponse,
    CategoryDetails,
    CategoryEntity,
    type ICategoryDetails,
    type ILeadActivityCategoryDetails,
} from "./Category.api.types";

export interface ICategoryDetailHandler {
    get(
        id: number,
        categoryType: CategoryType,
    ): Promise<ICategoryDetails | ILeadActivityCategoryDetails>;
    insert(category: CategoryEntity): Promise<CategoryEntity>;
    update(category: CategoryEntity): Promise<CategoryEntity>;
    delete(
        id: number,
        categoryType: CategoryType,
        allowDeleteExistingRefs: boolean,
    ): Promise<CategoryDeleteResponse>;
}

export class CategoryDetailHandler implements ICategoryDetailHandler {
    async get(
        id: number,
        categoryType: CategoryType,
    ): Promise<ICategoryDetails | ILeadActivityCategoryDetails> {
        return await APIHandler(`/api/Category/${id}`, {
            method: "GET",
            data: { categoryType },
            responseType: CategoryDetails,
        });
    }
    async insert(category: CategoryEntity): Promise<CategoryEntity> {
        return await APIHandler(`/api/Category`, {
            method: "POST",
            data: category,
            responseType: CategoryEntity,
        });
    }
    async update(category: CategoryEntity): Promise<CategoryEntity> {
        const { id, ...request } = category;
        return await APIHandler(`/api/Category/${id}`, {
            method: "PUT",
            data: request,
            responseType: CategoryEntity,
        });
    }
    async delete(
        id: number,
        categoryType: CategoryType,
        allowDeleteExistingRefs: boolean,
    ): Promise<CategoryDeleteResponse> {
        return await APIHandler(`/api/Category/${id}`, {
            method: "DELETE",
            data: {
                categoryType,
                allowDeleteExistingRefs,
            },
            responseType: CategoryDeleteResponse,
        });
    }
}
